import footerBgImg from "@imagesgz/footer-bg.png"
import logoImg from "@imagesgz/logo.png"
import sponsorsImg from "@imagesgz/sponsors.png"
import sponsorsAppImg from "@imagesgz/sponsors-app.png"
import Container from "@src/components/container"
import ResponsiveImage from "@src/components/responsiveContent/image"
import React from "react"
import * as styles from "./footer.module.scss"

const Footer = () => {
  return (
    <div className={styles.footer}>
      <Container>
        <img src={logoImg} alt="logo" />
      </Container>
      <img className={styles.footerImg} src={footerBgImg} alt="footer" />
      <div className={styles.sponsors}>
        <Container>
          <ResponsiveImage pc={sponsorsImg} mobile={sponsorsAppImg} />
        </Container>
      </div>
    </div>
  )
}

export default Footer
